import { useMutation, useQueryClient } from "@tanstack/react-query";
import { RelabelCaseService } from "src/services/relabelCases";
import { queryKeys } from "src/constants";

const useConfirmCasePlacement = (relabelCaseService: RelabelCaseService, onSuccess?: () => void) => {
  const queryClient = useQueryClient();

  const { mutateAsync: confirmPlacement, isPending: isConfirming } = useMutation({
    mutationFn: ({ caseId, locationId }: { caseId: string; locationId: string }) =>
      relabelCaseService.confirmCasePlacement(caseId, locationId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.buildingPallets() });
      queryClient.invalidateQueries({ queryKey: queryKeys.paginatedRelabelCases() });
      queryClient.invalidateQueries({ queryKey: queryKeys.relabelCaseStats() });
      queryClient.invalidateQueries({ queryKey: queryKeys.palletStats() });
      queryClient.invalidateQueries({ queryKey: queryKeys.palletLocations() });
      queryClient.invalidateQueries({ queryKey: queryKeys.completeCases() });
      onSuccess?.();
    }
  });

  return { confirmPlacement, isConfirming };
};

export { useConfirmCasePlacement };
